import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';

import { TUserMeta, TUserMetaResponse, adaptUserMetaUndefinedFromResponse } from './user-meta.type';


export const AccountClientSortCol = {
	ID: 'id',
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TAccountClientListSortCol = TTableSortCols<typeof AccountClientSortCol>;

export type TAccountClientQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TAccountClientListSortCol;
};

export type TAccountClientQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptAccountClientListQueryToRequest(data: TAccountClientQuery): TAccountClientQueryRequest {
	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TAccountClient = {
  id: number;
  lastName: string;
  firstName: string;
  thirdName?: string;
  description?: string;
	createdAt: string;
  updatedAt: string;

	createdBy?: TUserMeta;
	updatedBy?: TUserMeta;
};

export type TAccountClientResponse = {
  id: number;
  last_name: string;
  first_name: string;
  third_name?: string;
  description?: string;
  created_at: string;
  updated_at: string;

	created_by: TUserMetaResponse;
	updated_by: TUserMetaResponse;
};

export type TAccountClientListResponse = TListResponse<TAccountClientResponse>;

export type TAccountClientList = TListResponse<TAccountClient>;

export type TAccountClientBodyRequest = {
	lastName?: string;
	firstName?: string;
	thirdName?: string;
	description?: string;
};

export type TAccountClientRequest = {
	last_name?: string;
	first_name?: string;
	third_name?: string;
	description?: string;
};

export type TAccountClientUpdate = {
	id: number;
	data: TAccountClientBodyRequest;
};

export function adaptAccountClientFromListResponse(data: TAccountClientListResponse): TAccountClientList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptAccountClientFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptAccountClientFromResponse(data: TAccountClientResponse): TAccountClient {
	const {
		id,
		last_name: lastName = '',
		first_name: firstName = '',
		third_name: thirdName = '',
		description,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
		created_at: createdAt,
		updated_at: updatedAt,
	} = data;

	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		lastName,
		firstName,
		thirdName,
		description,
		createdBy,
		updatedBy,
		createdAt,
		updatedAt,
	};
}

export function adaptAccountClientToRequest(data: TAccountClientBodyRequest): TAccountClientRequest {
	const {
		lastName = '',
		firstName = '',
		thirdName = '',
		description = undefined,
	} = data;

	return {
		last_name: lastName,
		first_name: firstName,
		third_name: thirdName,
		description: description,
	};
}
